function initTheme() {
    
    /* --- Sticky Header Scroll Effect --- */
    const header = document.querySelector('.mega-header');
    
    window.addEventListener('scroll', () => {
        if (window.scrollY > 10) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });

    /* --- Announcement Bar Auto-Slide --- */
    const announcementSlides = document.querySelectorAll('.announcement-slide');
    let currentAnnouncementIndex = 0;

    if (announcementSlides.length > 1) {
        setInterval(() => {
            // Remove active from current
            announcementSlides[currentAnnouncementIndex].classList.remove('active');
            
            // Move to next
            currentAnnouncementIndex = (currentAnnouncementIndex + 1) % announcementSlides.length;
            
            // Add active to new
            announcementSlides[currentAnnouncementIndex].classList.add('active');
        }, 4000); // 4 seconds interval
    }

    /* --- Hero Slideshow --- */
    const slides = document.querySelectorAll('.slide');
    let currentSlideIndex = 0;
    let slideInterval;
    const SLIDE_DURATION = 6000; // 6 seconds per slide

    function goToSlide(index) {
        if (index === currentSlideIndex) return;

        // Remove active class from current slide
        slides[currentSlideIndex].classList.remove('active');
        
        // Update index
        currentSlideIndex = index;
        
        // Add active class to new slide
        slides[currentSlideIndex].classList.add('active');
    }

    function nextSlide() {
        let nextIndex = (currentSlideIndex + 1) % slides.length;
        goToSlide(nextIndex);
    }

    // Initialize auto-play
    function startSlideShow() {
        if (slideInterval) {
            clearInterval(slideInterval);
        }
        slideInterval = setInterval(nextSlide, SLIDE_DURATION);
    }

    // Start the slideshow initially
    if (slides.length > 1) {
        startSlideShow();
    }

    /* --- Hamburger Mobile Menu --- */
    const hamburgerBtn = document.getElementById('hamburgerBtn');
    const mobileNavPanel = document.getElementById('mobileNavPanel');
    const mobileNavOverlay = document.getElementById('mobileNavOverlay');
    const mobileNavClose = document.getElementById('mobileNavClose');

    function openMobileNav() {
        mobileNavPanel.classList.add('open');
        mobileNavOverlay.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    function closeMobileNav() {
        mobileNavPanel.classList.remove('open');
        mobileNavOverlay.classList.remove('open');
        document.body.style.overflow = '';
    }

    if (hamburgerBtn) hamburgerBtn.addEventListener('click', openMobileNav);
    if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
    if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

    /* --- Universal Mouse Drag-to-Scroll --- */
    function enableDragToScroll(containerSelector) {
        const containers = document.querySelectorAll(containerSelector);
        
        containers.forEach(slider => {
            let isDown = false;
            let startX;
            let scrollLeft;
            let hasDragged = false;  // tracks if a real drag occurred this press

            slider.addEventListener('mousedown', (e) => {
                isDown = true;
                hasDragged = false;
                slider.classList.add('active-drag');
                startX = e.pageX - slider.offsetLeft;
                scrollLeft = slider.scrollLeft;
            });
            
            slider.addEventListener('mouseleave', () => {
                isDown = false;
                hasDragged = false;
                slider.classList.remove('active-drag');
            });
            
            slider.addEventListener('mouseup', () => {
                isDown = false;
                // Reset hasDragged AFTER a short delay so the click event
                // (which fires after mouseup) can still read the correct value,
                // then we clear it so the next press starts clean.
                setTimeout(() => {
                    hasDragged = false;
                }, 0);
                slider.classList.remove('active-drag');
            });
            
            slider.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                const x = e.pageX - slider.offsetLeft;
                const walk = (x - startX) * 2;
                // Only register as a drag if movement exceeds 8px threshold
                if (Math.abs(x - startX) > 8) {
                    hasDragged = true;
                    e.preventDefault();
                    slider.scrollLeft = scrollLeft - walk;
                }
            });

            // Block link navigation ONLY during a confirmed drag — never on clean clicks
            slider.addEventListener('click', (e) => {
                if (hasDragged) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            }, true); // capture phase so we intercept before child <a> handlers
        });
    }

    // Enable drag-to-scroll for all slider tracks
    // (We will update CSS to use native overflow-x: auto for these)
    enableDragToScroll('.pslider-track');
    enableDragToScroll('.curate-grid');
    enableDragToScroll('.worth-hype-products');
    enableDragToScroll('.reviews-slider-track');
    enableDragToScroll('.sheglam-mtl-track');

    /* --- Banner Touch (Mobile tap to reveal panel) --- */
    document.querySelectorAll('.hp-banner, .twilight-banner').forEach(banner => {
        banner.addEventListener('click', () => {
            banner.classList.toggle('banner-active');
        });
    });

    /* --- More to Love Carousel --- */
    const mtlTrack = document.querySelector('.mtl-track');
    // Target the wrapper (which holds card + button together)
    const mtlCards = document.querySelectorAll('.mtl-product-wrapper, .mtl-card');

    // Remove buttons from DOM logic, keep auto-play and active class
    if (mtlTrack && mtlCards.length > 0) {
        let isTransitioning = false;
        
        function updateActiveCard() {
            const currentCards = document.querySelectorAll('.mtl-product-wrapper, .mtl-card');
            currentCards.forEach(card => card.classList.remove('active'));
            // Center is usually the 3rd card if there are 5 visible, or 2nd on mobile
            let activeIdx = window.innerWidth <= 768 ? 1 : 2;
            if (currentCards.length > activeIdx) {
                currentCards[activeIdx].classList.add('active');
            } else {
                currentCards[0].classList.add('active');
            }
        }
        
        updateActiveCard();

        // Update on resize
        window.addEventListener('resize', updateActiveCard);

        function moveNext() {
            if (isTransitioning) return;
            isTransitioning = true;
            
            const currentCards = document.querySelectorAll('.mtl-product-wrapper, .mtl-card');
            const cardWidth = currentCards[0].offsetWidth + 30; // 30 is margin
            
            mtlTrack.style.transition = 'transform 0.5s ease-in-out';
            mtlTrack.style.transform = `translateX(-${cardWidth}px)`;
            
            currentCards.forEach(card => card.classList.remove('active'));
            let nextActiveIdx = window.innerWidth <= 768 ? 2 : 3;
            if (currentCards.length > nextActiveIdx) {
                currentCards[nextActiveIdx].classList.add('active'); 
            }
             
            setTimeout(() => {
                mtlTrack.style.transition = 'none';
                mtlTrack.style.transform = 'translateX(0)';
                mtlTrack.appendChild(currentCards[0]);
                isTransitioning = false;
            }, 500);
        }

        // Auto-play
        let mtlInterval = setInterval(moveNext, 3500);
        
        // Add basic swipe support for More To Love
        let touchStartX = 0;
        mtlTrack.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
        mtlTrack.addEventListener('touchend', e => {
            const diff = touchStartX - e.changedTouches[0].clientX;
            if (diff > 50) {
                clearInterval(mtlInterval);
                moveNext();
                mtlInterval = setInterval(moveNext, 3500);
            }
        }, { passive: true });
    }

    /* --- Universal Auto Slider for Mobile & Desktop --- */
    function initAutoSlider(trackSelector, itemSelector, intervalMs, dotsSelector = null, mobileOnly = false) {
        const tracks = document.querySelectorAll(trackSelector);
        
        tracks.forEach((track) => {
            let items = Array.from(track.querySelectorAll(itemSelector));
            if (mobileOnly) {
                // filter out desktop-only items
                items = items.filter(item => !item.classList.contains('desktop-only'));
            }
            if (items.length <= 1) return;
            
            let currentIndex = 0;
            let sliderInterval;
            let dotsContainer = dotsSelector ? document.querySelector(dotsSelector) : null;
            
            if (dotsContainer) {
                dotsContainer.innerHTML = '';
                items.forEach((_, i) => {
                    const dot = document.createElement('span');
                    dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
                    dotsContainer.appendChild(dot);
                    
                    // Allow clicking dots to navigate
                    dot.addEventListener('click', () => {
                        currentIndex = i;
                        scrollToCurrent();
                        resetInterval();
                    });
                });
            }
            
            function scrollToCurrent() {
                if (items.length === 0) return;
                const itemWidth = items[0].offsetWidth;
                const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
                const scrollPos = currentIndex * (itemWidth + gap);
                
                track.scrollTo({ left: scrollPos, behavior: 'smooth' });
                
                if (dotsContainer) {
                    const dots = dotsContainer.querySelectorAll('.slider-dot');
                    dots.forEach((dot, i) => {
                        dot.classList.toggle('active', i === currentIndex);
                    });
                }
            }
            
            function updateSlider() {
                if (mobileOnly && window.innerWidth > 768) {
                    if (sliderInterval) {
                        clearInterval(sliderInterval);
                        sliderInterval = null;
                    }
                    return;
                }
                
                currentIndex = (currentIndex + 1) % items.length;
                scrollToCurrent();
            }
            
            function startSlider() {
                if (!sliderInterval) {
                    sliderInterval = setInterval(updateSlider, intervalMs);
                }
            }
            
            function resetInterval() {
                if (sliderInterval) {
                    clearInterval(sliderInterval);
                    startSlider();
                }
            }
            
            // Initial check
            if (!mobileOnly || window.innerWidth <= 768) {
                startSlider();
            }
            
            window.addEventListener('resize', () => {
                if (mobileOnly) {
                    if (window.innerWidth <= 768) startSlider();
                    else {
                        if (sliderInterval) clearInterval(sliderInterval);
                        sliderInterval = null;
                    }
                }
            });
            
            // Update index on manual scroll
            track.addEventListener('scroll', () => {
                if (mobileOnly && window.innerWidth > 768) return;
                const itemWidth = items[0].offsetWidth;
                const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
                const scrollLeft = track.scrollLeft;
                currentIndex = Math.round(scrollLeft / (itemWidth + gap));
                
                if (dotsContainer) {
                    const dots = dotsContainer.querySelectorAll('.slider-dot');
                    dots.forEach((dot, i) => {
                        dot.classList.toggle('active', i === currentIndex);
                    });
                }
            });
        });
    }

    // Initialize the sliders requested by user (2 seconds = 2000ms)
    // Worth the Hype - Universal Slider (Mobile Only)
    initAutoSlider('.worth-hype-products', '.wth-card-new', 2000, '.wth-slider-dots', true);
    
    // Reviews / Hot Takes - Mobile & Desktop Slider
    initAutoSlider('.reviews-slider-track', '.review-item', 2000, '.reviews-dots', false);
    
    // Built on Beliefs / Core Values - Mobile & Desktop Slider
    initAutoSlider('.core-values-grid', '.value-item', 2000, '.values-dots', false);

    /* --- Dynamic Product Ribbon Highlights Matching & Injection --- */
    function initDynamicProductHighlights() {
        const highlightDataset = {
            "Moisturizing Matte Lipstick - 4.2g": ["SMUDGE-PROOF", "LONG-LASTING", "RICH PIGMENT", "COMFORTABLE WEAR"],
            "3 Ultra Soft Matte Lipstick Kit + Free Waterproof Eyeliner": ["ULTRA SOFT FINISH", "LONG-LASTING COLOR", "WATERPROOF EYELINER", "EVERYDAY GLAM"],
            "4 Glamorous Lipstick Kit - SPF 25 + FREE Waterproof Eyeliner": ["SPF 25 PROTECTION", "RICH COLOR PAYOFF", "WATERPROOF EYELINER", "SMOOTH APPLICATION"],
            "4 Trending Liquid Lipstick Kit": ["TRENDY SHADES", "SMUDGE-PROOF", "LONG WEAR", "LIGHTWEIGHT FORMULA"],
            "4 Must-Have Liquid Lipstick Kit": ["HIGHLY PIGMENTED", "NON-DRYING", "LONG-LASTING", "SMOOTH FINISH"],
            "Pack of 4 Hydrating & High Shine Lip Glosses": ["HIGH SHINE FINISH", "HYDRATING FORMULA", "NON-STICKY FEEL", "EVERYDAY WEAR"],
            "Lips Moisturizing Balm BM": ["DEEP HYDRATION", "SOFT LIPS", "DAILY CARE", "NON-STICKY FORMULA"],
            "3 Glittery Coloured Eyeliners Kit": ["VIBRANT COLORS", "GLITTER EFFECT", "LONG WEAR", "EASY GLIDE"],
            "Combo Pack Of Eyeliner & Kajal": ["INTENSE BLACK", "SMOOTH APPLICATION", "LONG-LASTING", "EYE DEFINING LOOK"],
            "Most Loved Eyeshadow Palette": ["HIGHLY PIGMENTED", "BLENDABLE SHADES", "SMOOTH TEXTURE", "VERSATILE LOOKS"],
            "MRZ Coloured Glitter Eyeliner": ["SPARKLING FINISH", "BOLD COLORS", "EASY APPLICATION", "LONG WEAR"],
            "Pack Of 9 Eyeshadows": ["9 STUNNING SHADES", "EASY BLENDING", "RICH PIGMENT", "DAY TO NIGHT LOOKS"],
            "4 Stunning Eyeshadows Combo + Free Eyeliner": ["RICH COLOR PAYOFF", "EASY BLENDING", "COMPLETE EYE LOOK", "FREE EYELINER"],
            "Pop Colored Eyeliner Pack": ["POP COLORS", "SMUDGE RESISTANT", "SMOOTH GLIDE", "CREATIVE LOOKS"],
            "Colored Eyeliner": ["VIBRANT SHADES", "PRECISION APPLICATION", "LONG WEAR", "EYE-CATCHING FINISH"],
            "FREE Eyeliner": ["INTENSE COLOR", "SMOOTH GLIDE", "EASY APPLICATION", "LONG WEAR"],
            "10 Hour Long-Stay Intense Kajal": ["10 HOUR WEAR", "INTENSE BLACK", "SMUDGE RESISTANT", "SMOOTH GLIDE"],
            "Matte Silky Touch Compact Powder": ["SILKY SMOOTH FINISH", "LIGHTWEIGHT FEEL", "NATURAL COVERAGE", "SHINE CONTROL"],
            "Men Activated Charcoal Face Wash": ["DEEP CLEANSING", "OIL CONTROL", "REMOVES IMPURITIES", "REFRESHING FEEL"],
            "Men Activated Charcoal Face Scrub": ["GENTLE EXFOLIATION", "UNCLOGS PORES", "REMOVES DEAD SKIN", "FRESH LOOK"],
            "After Shave Balm with Fitkari": ["SOOTHES SKIN", "REDUCES IRRITATION", "COOLING EFFECT", "HYDRATING CARE"],
            "Jade Roller - Face Massager Tool": ["IMPROVES CIRCULATION", "REDUCES PUFFINESS", "RELAXING MASSAGE", "HEALTHY GLOW"],
            "Moraze Combo of Men Face Wash and Face Scrub": ["DEEP CLEANSE", "OIL CONTROL", "EXFOLIATING CARE", "DAILY GROOMING"],
            "Blush Brush": ["SOFT BRISTLES", "EVEN BLENDING", "SMOOTH APPLICATION", "PROFESSIONAL FINISH"],
            "Highlighter Brush": ["PRECISION APPLICATION", "SOFT BRISTLES", "NATURAL GLOW", "EASY BLENDING"],
            "Foundation Brush": ["STREAK-FREE FINISH", "SMOOTH COVERAGE", "SOFT BRISTLES", "EASY APPLICATION"],
            "Glow Essentials Combo": ["COMPLETE SKINCARE", "DEEP CLEANSING", "HEALTHY GLOW", "DAILY CARE"],
            "Face Serum For All Your Skin Concerns + FREE Face Roller": ["DEEP HYDRATION", "HEALTHY GLOW", "LIGHTWEIGHT FORMULA", "FREE FACE ROLLER"],
            "Mens Combo Kit - Face Wash, Face Scrub & Lipcare": ["COMPLETE GROOMING", "DEEP CLEANSING", "LIP CARE SUPPORT", "EVERYDAY FRESHNESS"],
            "Moraze Men Activated Charcoal Pollution & Oil Control Face Scrub & Face Wash": ["POLLUTION DEFENSE", "OIL CONTROL", "DEEP CLEANSING", "HEALTHY LOOKING SKIN"],
            "Men Activated Charcoal Face Wash - 100ML BM": ["CHARCOAL POWER", "DEEP CLEANSE", "OIL CONTROL", "REFRESHING FEEL"],
            "5 Glamorous Nail Polish Kit": ["RICH COLOR PAYOFF", "GLOSSY FINISH", "SMOOTH APPLICATION", "LONG WEAR"],
            "Neon Pack Of 6 Nail Polish With Top Coat": ["VIBRANT NEON SHADES", "EXTRA GLOSS FINISH", "QUICK DRY FORMULA", "LONG LASTING WEAR"],
            "Moraze Mini Nail Polish Pack of 24": ["24 TRENDY SHADES", "HIGH PIGMENTATION", "SMOOTH APPLICATION", "CREATIVE NAIL LOOKS"],
            "Moraze Mini Nail Polish Pack of 12": ["12 STUNNING SHADES", "GLOSSY FINISH", "EASY APPLICATION", "EVERYDAY STYLE"],
            "Moraze 5 Trending Nail Polish Kit": ["TRENDING COLORS", "HIGH SHINE FINISH", "SMOOTH GLIDE", "LONG WEAR"],
            "Nail Paint Pack – 10 Highly Glossy Pigmented Shades": ["10 VIBRANT SHADES", "HIGHLY PIGMENTED", "ULTRA GLOSSY FINISH", "SMOOTH APPLICATION"],
            "4 Glamorous Glossy Nail Polish Kit + FREE Top Coat": ["HIGH GLOSS FINISH", "LONG LASTING WEAR", "SMOOTH APPLICATION", "FREE TOP COAT"],
            "Luxury Body Perfumes Pack of 4": ["LONG LASTING FRAGRANCE", "PREMIUM SCENT COLLECTION", "EVERYDAY LUXURY", "TRAVEL FRIENDLY"],
            "Long Lasting Pack of 6 Perfume Set": ["6 UNIQUE FRAGRANCES", "LONG LASTING AROMA", "PREMIUM BLEND", "PERFECT FOR EVERY MOOD"],
            "Unisex Perfume - 10ML": ["FRESH FRAGRANCE", "LONG LASTING WEAR", "COMPACT & PORTABLE", "EVERYDAY ESSENTIAL"],
            "Intense Perfume For Men": ["BOLD MASCULINE SCENT", "LONG LASTING PERFORMANCE", "PREMIUM FRAGRANCE", "CONFIDENT PRESENCE"],
            "Rare Perfume For Men": ["UNIQUE FRAGRANCE PROFILE", "LONG LASTING AROMA", "PREMIUM QUALITY", "SIGNATURE SCENT"],
            "Crystal Perfume For Women": ["ELEGANT FLORAL NOTES", "LONG LASTING FRAGRANCE", "SOPHISTICATED SCENT", "EVERYDAY LUXURY"],
            "Desire Perfume For Women": ["CAPTIVATING FRAGRANCE", "LONG LASTING WEAR", "PREMIUM BLEND", "FEMININE ELEGANCE"],
            "Refreshing Body Mist Kit": ["INSTANT FRESHNESS", "LIGHT FRAGRANCE", "DAILY REFRESH", "EASY TO CARRY"],
            "Mini Pocket Perfume Pack of 2": ["POCKET FRIENDLY", "LONG LASTING AROMA", "TRAVEL READY", "EVERYDAY USE"]
        };

        function generateDynamicUSPs(title) {
            const lowerTitle = title.toLowerCase();
            if (lowerTitle.includes('lipstick') || lowerTitle.includes('lip gloss') || lowerTitle.includes('lip-gloss') || lowerTitle.includes('lip play') || lowerTitle.includes('lip tint') || lowerTitle.includes('lip crayon') || lowerTitle.includes('liquid lip') || lowerTitle.includes('lip color') || lowerTitle.includes('lip colour') || lowerTitle.includes('matte lip')) {
                return ["RICH COLOR PAYOFF", "SMUDGE-PROOF FINISH", "HYDRATING FORMULA", "ALL-DAY COMFORT WEAR"];
            } else if (lowerTitle.includes('eyeliner') || lowerTitle.includes('kajal') || lowerTitle.includes('mascara') || lowerTitle.includes('eyeshadow') || lowerTitle.includes('eye shadow') || lowerTitle.includes('palette') || lowerTitle.includes('brow') || lowerTitle.includes('lash') || lowerTitle.includes('eye')) {
                return ["INTENSE PIGMENT", "WATERPROOF FORMULA", "SMUDGE-PROOF WEAR", "ALL-DAY DEFINITION"];
            } else if (lowerTitle.includes('nail')) {
                return ["HIGH-SHINE FINISH", "CHIP-RESISTANT", "QUICK DRY FORMULA", "LONG-LASTING COLOR"];
            } else if (lowerTitle.includes('face wash') || lowerTitle.includes('facewash') || lowerTitle.includes('cleanser') || lowerTitle.includes('scrub') || lowerTitle.includes('exfoliator') || lowerTitle.includes('peel')) {
                return ["DEEP PORE CLEANSING", "OIL & SEBUM CONTROL", "REMOVES IMPURITIES", "REFRESHING SKIN FEEL"];
            } else if (lowerTitle.includes('serum') || lowerTitle.includes('essence') || lowerTitle.includes('oil') || lowerTitle.includes('elixir') || lowerTitle.includes('brightening')) {
                return ["DEEP SKIN HYDRATION", "BRIGHTENS DULL SKIN", "LIGHTWEIGHT ABSORPTION", "RESTORES NATURAL GLOW"];
            } else if (lowerTitle.includes('perfume') || lowerTitle.includes('mist') || lowerTitle.includes('spray') || lowerTitle.includes('fragrance') || lowerTitle.includes('cologne') || lowerTitle.includes('deodorant') || lowerTitle.includes('scent')) {
                return ["LONG-LASTING FRAGRANCE", "PREMIUM SCENT PROFILE", "ELEGANT & LUXURIOUS", "PERFECT FOR EVERYDAY"];
            } else if (lowerTitle.includes('moisturizer') || lowerTitle.includes('cream') || lowerTitle.includes('lotion') || lowerTitle.includes('balm') || lowerTitle.includes('sunscreen') || lowerTitle.includes('spf') || lowerTitle.includes('hydrator') || lowerTitle.includes('lip')) {
                return ["INTENSE HYDRATION", "BARRIER PROTECTION", "NON-GREASY FORMULA", "SOFT & SUPPLE SKIN"];
            } else if (lowerTitle.includes('brush') || lowerTitle.includes('applicator') || lowerTitle.includes('blender') || lowerTitle.includes('tool') || lowerTitle.includes('roller') || lowerTitle.includes('massager')) {
                return ["PRESTIGE SOFT BRISTLES", "FLAWLESS APPLICATION", "EVEN PRODUCT BLENDING", "PROFESSIONAL DESIGN"];
            } else {
                return ["HIGH-PERFORMANCE", "DERMATOLOGICALLY TESTED", "CRUELTY-FREE FORMULA", "SUITABLE FOR ALL SKIN TYPES"];
            }
        }

        const cards = document.querySelectorAll('.ag-product-card, .moraze-london-card');
        cards.forEach(card => {
            const rawTitle = card.getAttribute('data-product-title') || card.querySelector('.ag-product-title, .product-title-block')?.textContent?.trim();
            if (!rawTitle) return;

            // Find matching product in dataset (fuzzy match based on lowercase containment)
            let matchedHighlights = null;
            const searchTitle = rawTitle.toLowerCase().trim();

            // Try exact title matching first for high specificity
            for (const key in highlightDataset) {
                if (searchTitle === key.toLowerCase().trim()) {
                    matchedHighlights = highlightDataset[key];
                    break;
                }
            }

            // Try fuzzy match if exact match fails
            if (!matchedHighlights) {
                for (const key in highlightDataset) {
                    if (searchTitle.includes(key.toLowerCase().trim()) || key.toLowerCase().trim().includes(searchTitle)) {
                        matchedHighlights = highlightDataset[key];
                        break;
                    }
                }
            }

            // Generate fallback dynamic USPs if still no match found
            if (!matchedHighlights) {
                matchedHighlights = generateDynamicUSPs(rawTitle);
            }

            // Inject dynamically into the yellow ribbon scroller or hide container
            const bar = card.querySelector('.ag-feature-bar, .dewy-glow-bar');
            if (matchedHighlights && matchedHighlights.length > 0) {
                const scroller = card.querySelector('.ag-feature-scroller');
                if (scroller) {
                    scroller.innerHTML = '';
                    scroller.classList.remove('ag-scroll-3', 'ag-scroll-4', 'ag-scroll-5');
                    scroller.classList.add(`ag-scroll-${matchedHighlights.length}`);

                    matchedHighlights.forEach(word => {
                        const wordDiv = document.createElement('div');
                        wordDiv.className = 'ag-feature-word';
                        wordDiv.textContent = word;
                        scroller.appendChild(wordDiv);
                    });
                }
                if (bar) {
                    bar.style.display = ''; // Show container if mappings exist
                }
            } else {
                if (bar) {
                    bar.style.display = 'none'; // Hide container if no mappings exist
                }
            }
        });
    }

    // Run dynamic highlights matching
    initDynamicProductHighlights();

    // Run centralized Trustoo observer for collection/pdp cards
    initTrustooCardsObserver();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTheme);
} else {
    initTheme();
}

/* ============================================
   CART DRAWER LOGIC
   ============================================ */

window.openCartDrawer = function() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.add('open');
    document.body.classList.add('cart-drawer-open');
    document.body.style.overflow = 'hidden';
    
    // Auto-check milestones when drawer opens to ensure gifts are synced
    if (typeof window.checkCartMilestones === 'function') {
        window.checkCartMilestones();
    }
};

window.closeCartDrawer = function() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.remove('open');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';
};

// Update Cart Drawer via Section Rendering API (with cache-buster)
window.updateCartDrawer = function() {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    fetch(rootUrl + '?section_id=cart-drawer&t=' + Date.now())
        .then(res => res.text())
        .then(text => {
            const temp = document.createElement('div');
            temp.innerHTML = text;
            // Try new class first, fall back to old
            const newContent = temp.querySelector('.cart-drawer__content');
            const currentContent = document.querySelector('.cart-drawer__content');
            if (newContent && currentContent) {
                currentContent.innerHTML = newContent.innerHTML;
            }
            // Dispatch custom event to notify listeners (e.g. milestone checker)
            document.dispatchEvent(new CustomEvent('cart-drawer:updated'));
        })
        .catch(e => console.error('Error updating cart:', e));
};

// Debounce trackers for quantity updates
const cartUpdateTimeouts = {};
const pendingQuantities = {};

// Helper to calculate progress percentage for milestones progress bar
function getProgressPct(cartTotal, freeShippingThreshold, milestones) {
    if (milestones.length === 0) {
        return cartTotal >= freeShippingThreshold ? 100 : (cartTotal / freeShippingThreshold * 100);
    }

    const maxThreshold = Math.max(freeShippingThreshold, ...milestones.map(m => m.threshold));
    const nodeCount = milestones.length + 1;
    const segmentPct = 100 / nodeCount;

    if (cartTotal >= maxThreshold) {
        return 100;
    }

    if (cartTotal < freeShippingThreshold) {
        return (cartTotal / freeShippingThreshold) * segmentPct;
    }

    // We are between freeShippingThreshold and maxThreshold
    let mzProgressPct = 0;
    let prevThreshold = freeShippingThreshold;
    for (let i = 0; i < milestones.length; i++) {
        const blkThreshold = milestones[i].threshold;
        if (cartTotal < blkThreshold && mzProgressPct === 0) {
            const segRange = blkThreshold - prevThreshold;
            const segFill = ((cartTotal - prevThreshold) / segRange) * segmentPct;
            const segBase = (i + 1) * segmentPct;
            mzProgressPct = segBase + segFill;
        }
        prevThreshold = blkThreshold;
    }
    return mzProgressPct || 100;
}

// Helper to update milestones progress bar UI
function updateMilestoneProgressUI(cartTotal, freeShippingThreshold) {
    const milestonesEl = document.getElementById('mz-milestones-data');
    if (!milestonesEl) return;

    let milestonesData;
    try {
        milestonesData = JSON.parse(milestonesEl.textContent);
    } catch(e) {
        console.error('[Moraze] Error parsing milestones data for optimistic UI:', e);
        return;
    }

    const milestones = milestonesData.milestones || [];
    const maxThreshold = Math.max(freeShippingThreshold, ...milestones.map(m => m.threshold));
    const allUnlocked = cartTotal >= maxThreshold;

    // 1. Calculate percentage
    const progressPct = getProgressPct(cartTotal, freeShippingThreshold, milestones);
    const progressFill = document.querySelector('.cd-progress-fill');
    if (progressFill) {
        progressFill.style.width = Math.round(progressPct) + '%';
    }

    // 2. Update Free Shipping Node
    const shippingNode = document.querySelector('.cd-progress-nodes > .cd-node:first-child');
    if (shippingNode) {
        const isDone = cartTotal >= freeShippingThreshold;
        shippingNode.classList.toggle('cd-node--done', isDone);
        const circle = shippingNode.querySelector('.cd-node-circle');
        if (circle) circle.classList.toggle('cd-node-circle--active', isDone);
        const label = shippingNode.querySelector('span');
        if (label) label.classList.toggle('cd-node-label--active', isDone);
    }

    // 3. Update Milestone Nodes
    let nextLabel = '';
    let nextAmount = 0;

    if (cartTotal < freeShippingThreshold) {
        nextLabel = 'Free Shipping';
        nextAmount = freeShippingThreshold - cartTotal;
    }

    const itemRows = document.querySelectorAll('.cd-item');

    milestones.forEach((milestone, idx) => {
        const node = document.querySelector(`.cd-node[data-milestone-index="${idx}"]`);
        const threshold = milestone.threshold;
        const isDone = cartTotal >= threshold;

        if (cartTotal < threshold && nextLabel === '') {
            nextLabel = milestone.label || 'Free Gift';
            nextAmount = threshold - cartTotal;
        }

        if (node) {
            node.classList.toggle('cd-node--done', isDone);
            const circle = node.querySelector('.cd-node-circle');
            if (circle) circle.classList.toggle('cd-node-circle--active', isDone);
            const label = node.querySelector('span');
            if (label) label.classList.toggle('cd-node-label--active', isDone);

            // Handle claim button / status
            let btn = node.querySelector('.claim-gift-btn');
            let status = node.querySelector('.claim-gift-status');

            // Find if this gift is currently in cart
            const giftInCart = Array.from(itemRows).some(row => {
                const key = row.getAttribute('data-key') || '';
                const isFreeGift = row.getAttribute('data-is-free-gift') === 'true';
                let qty = 0;
                if (pendingQuantities.hasOwnProperty(key)) {
                    qty = pendingQuantities[key];
                } else {
                    const qtyValEl = row.querySelector('.cd-qty-val');
                    if (qtyValEl) qty = parseInt(qtyValEl.textContent.trim(), 10) || 0;
                }
                return key.startsWith(milestone.variantId.toString()) && isFreeGift && qty > 0;
            });

            if (isDone) {
                if (giftInCart) {
                    if (btn) btn.remove();
                    if (!status) {
                        status = document.createElement('span');
                        status.className = 'claim-gift-status';
                        status.style.cssText = 'font-size:0.55rem; color:#2E7D32; font-weight:700; margin-top:2px;';
                        status.textContent = 'Added';
                        node.appendChild(status);
                    }
                } else {
                    if (status) status.remove();
                    if (!btn) {
                        btn = document.createElement('button');
                        btn.type = 'button';
                        btn.className = 'claim-gift-btn';
                        btn.setAttribute('onclick', `claimMilestoneGift(${idx}, this); event.stopPropagation();`);
                        btn.textContent = 'Claim';
                        node.appendChild(btn);
                    }
                }
            } else {
                if (btn) btn.remove();
                if (status) status.remove();
            }
        }
    });

    // 4. Update progress message
    const progressMsgEl = document.querySelector('.cd-progress-msg');
    if (progressMsgEl) {
        if (allUnlocked) {
            progressMsgEl.className = 'cd-progress-msg cd-progress-msg--success';
            progressMsgEl.innerHTML = '🎉 <strong>Congrats! You have unlocked all free gifts!</strong>';
        } else if (cartTotal < freeShippingThreshold) {
            progressMsgEl.className = 'cd-progress-msg';
            progressMsgEl.innerHTML = `Add ₹${Math.ceil(freeShippingThreshold - cartTotal)} more for Free Shipping`;
        } else {
            progressMsgEl.className = 'cd-progress-msg cd-progress-msg--success';
            progressMsgEl.innerHTML = `🎁 Add ₹${Math.ceil(nextAmount)} more to unlock ${nextLabel}!`;
        }
    }
}

// Main Optimistic UI Cart update function
window.mzOptimisticCartUpdate = function() {
    const items = document.querySelectorAll('.cd-item');
    
    let totalCents = 0;
    let originalTotalCents = 0;
    let promoTotalCents = 0; // total excluding free gifts
    let regularItemsCount = 0; // paid items only (excludes free gifts)
    let totalItemsCount = 0;

    let freeShippingThreshold = 399; // default fallback
    const shippingSpan = document.querySelector('.js-cd-shipping');
    if (shippingSpan) {
        const thresholdAttr = shippingSpan.getAttribute('data-threshold');
        if (thresholdAttr) {
            freeShippingThreshold = parseFloat(thresholdAttr);
        }
    }

    items.forEach(item => {
        const key = item.getAttribute('data-key');
        const priceVal = parseFloat(item.getAttribute('data-price') || '0');
        const origPriceVal = parseFloat(item.getAttribute('data-original-price') || '0');
        const isFreeGift = item.getAttribute('data-is-free-gift') === 'true';

        let qty = 0;
        if (pendingQuantities.hasOwnProperty(key)) {
            qty = pendingQuantities[key];
        } else {
            const qtyValEl = item.querySelector('.cd-qty-val');
            if (qtyValEl) {
                qty = parseInt(qtyValEl.textContent.trim(), 10) || 0;
            }
        }

        if (qty <= 0) {
            return;
        }

        totalItemsCount += qty;

        if (isFreeGift) {
            originalTotalCents += origPriceVal * qty;
        } else {
            regularItemsCount += qty;
            totalCents += priceVal * qty;
            originalTotalCents += origPriceVal * qty;
            promoTotalCents += priceVal * qty;
        }
    });

    function formatCents(cents) {
        const symbol = (window.themeCurrency && window.themeCurrency.symbol) ? window.themeCurrency.symbol : '₹';
        const isoCode = (window.themeCurrency && window.themeCurrency.isoCode) ? window.themeCurrency.isoCode : 'INR';
        const dollars = cents / 100;
        if (isoCode === 'INR') {
            const rupees = Math.round(dollars);
            return symbol + rupees.toLocaleString('en-IN');
        }
        return symbol + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Update checkout button visibility and state based on whether updates are pending
    const checkoutBtn = document.querySelector('.cd-checkout-btn');
    const hasPendingUpdates = Object.keys(cartUpdateTimeouts).length > 0;
    if (checkoutBtn) {
        if (hasPendingUpdates) {
            checkoutBtn.classList.add('btn-loading');
            checkoutBtn.style.pointerEvents = 'none';
            checkoutBtn.style.opacity = '0.7';
            if (!checkoutBtn.getAttribute('data-orig-text')) {
                checkoutBtn.setAttribute('data-orig-text', checkoutBtn.innerHTML);
            }
            checkoutBtn.innerHTML = 'Updating...';
        } else {
            checkoutBtn.classList.remove('btn-loading');
            checkoutBtn.style.pointerEvents = '';
            checkoutBtn.style.opacity = '';
            const origText = checkoutBtn.getAttribute('data-orig-text');
            if (origText) {
                checkoutBtn.innerHTML = origText;
            }
        }
    }

    // "Effectively empty" = no regular paid items remain
    // (free gifts may still be in DOM but will be auto-removed by server)
    const effectivelyEmpty = (regularItemsCount === 0);

    if (effectivelyEmpty) {
        // Hide any remaining free gift rows — they are about to be auto-removed
        items.forEach(item => {
            const isFreeGift = item.getAttribute('data-is-free-gift') === 'true';
            if (isFreeGift) {
                item.style.transition = 'opacity 0.2s ease-out';
                item.style.opacity = '0';
                setTimeout(() => { item.style.display = 'none'; }, 200);
            }
        });

        // Keep milestone progress bar and "Cart Details" header visible (desired layout)
        const progressSection = document.querySelector('.cd-progress-section');
        const detailsHeader = document.querySelector('.cd-details-header');
        if (progressSection) progressSection.style.display = '';
        if (detailsHeader) detailsHeader.style.display = '';

        // Show "0 Items" in header
        const headerCount = document.querySelector('.cd-item-count');
        if (headerCount) headerCount.textContent = '0 Items';

        // Show the empty state, hide price summary and footer
        // Use 'block' not 'flex' — 'flex' without flex-direction:column makes
        // children lay out horizontally (icon | title | subtitle | button in a row)
        const emptyState = document.querySelector('.cd-empty-state');
        const priceSummary = document.querySelector('.cd-price-summary');
        const footer = document.querySelector('.cd-footer');
        if (emptyState) emptyState.style.display = 'block';
        if (priceSummary) priceSummary.style.display = 'none';
        if (footer) footer.style.display = 'none';

        // Update progress bar to reflect 0 cart value
        updateMilestoneProgressUI(0, freeShippingThreshold);

        // Reset header badge and floating bar
        const badge = document.querySelector('.mz-cart-count');
        if (badge) {
            badge.textContent = '0';
            badge.style.display = 'none';
        }
        const fcbItemCount = document.getElementById('fcb-item-count');
        if (fcbItemCount) fcbItemCount.textContent = '0 Items';
        const fcbPriceEl = document.getElementById('fcb-price');
        if (fcbPriceEl) fcbPriceEl.textContent = formatCents(0);
        const bar = document.getElementById('floating-cart-bar');
        if (bar) {
            bar.classList.remove('visible');
            document.body.classList.remove('has-floating-cart');
        }
        return;
    }

    // ---- Cart has regular paid items — show everything normally ----
    const detailsHeader = document.querySelector('.cd-details-header');
    const progressSection = document.querySelector('.cd-progress-section');
    const priceSummary = document.querySelector('.cd-price-summary');
    const footer = document.querySelector('.cd-footer');
    const emptyState = document.querySelector('.cd-empty-state');

    if (detailsHeader) detailsHeader.style.display = '';
    if (progressSection) progressSection.style.display = '';
    if (priceSummary) priceSummary.style.display = '';
    if (footer) footer.style.display = '';
    if (emptyState) emptyState.style.display = 'none';

    const headerCount = document.querySelector('.cd-item-count');
    if (headerCount) {
        headerCount.textContent = regularItemsCount + (regularItemsCount === 1 ? ' Item' : ' Items');
    }
    const badge = document.querySelector('.mz-cart-count');
    if (badge) {
        badge.textContent = regularItemsCount;
        badge.style.display = regularItemsCount > 0 ? 'flex' : 'none';
    }
    const fcbItemCount = document.getElementById('fcb-item-count');
    if (fcbItemCount) {
        fcbItemCount.textContent = regularItemsCount + (regularItemsCount === 1 ? ' Item' : ' Items');
    }

    const mrpTotalEl = document.querySelector('.js-cd-mrp-total');
    if (mrpTotalEl) {
        mrpTotalEl.textContent = formatCents(originalTotalCents);
    }

    const discountEl = document.querySelector('.js-cd-discount');
    if (discountEl) {
        const discountVal = originalTotalCents - totalCents;
        discountEl.textContent = '-' + formatCents(discountVal);
    }

    const promoTotalRupees = promoTotalCents / 100.0;
    const shippingEl = document.querySelector('.js-cd-shipping');
    if (shippingEl) {
        if (promoTotalRupees >= freeShippingThreshold) {
            shippingEl.innerHTML = '<span class="cd-free">FREE</span>';
        } else {
            shippingEl.innerHTML = `<span>${formatCents(5000)}</span>`;
        }
    }

    const orderTotalEl = document.querySelector('.js-cd-order-total');
    if (orderTotalEl) {
        orderTotalEl.textContent = formatCents(totalCents);
    }

    const footerTotalEl = document.querySelector('.js-cd-footer-total');
    if (footerTotalEl) {
        footerTotalEl.textContent = formatCents(totalCents);
    }
    const footerOrigTotalEl = document.querySelector('.js-cd-footer-original-total');
    if (footerOrigTotalEl) {
        footerOrigTotalEl.textContent = formatCents(originalTotalCents);
    }

    const fcbPriceEl = document.getElementById('fcb-price');
    if (fcbPriceEl) {
        fcbPriceEl.textContent = formatCents(totalCents);
    }
    const fcbBar = document.getElementById('floating-cart-bar');
    if (fcbBar && regularItemsCount > 0) {
        fcbBar.classList.add('visible');
        document.body.classList.add('has-floating-cart');
    }

    updateMilestoneProgressUI(promoTotalRupees, freeShippingThreshold);
};

// Handle Quantity Changes visually & debounce updates
window.changeCartQty = function(key, newQty) {
    if (newQty < 0) return;
    
    // 1. Instant UI Feedback: update targets immediately
    const itemRow = document.querySelector(`.cd-item[data-key="${key}"], .cart-item[data-key="${key}"]`);
    if (itemRow) {
        const qtyVal = itemRow.querySelector('.cd-qty-val');
        const qtyInput = itemRow.querySelector('.qty-input');
        if (qtyVal) qtyVal.textContent = newQty;
        if (qtyInput) qtyInput.value = newQty;

        if (newQty === 0) {
            itemRow.style.pointerEvents = 'none';
            itemRow.style.transition = 'all 0.2s ease-out';
            itemRow.style.opacity = '0';
            itemRow.style.transform = 'scale(0.9)';
            setTimeout(() => {
                itemRow.style.display = 'none';
            }, 200);
        }
    }

    pendingQuantities[key] = newQty;
    
    // Run optimistic UI update instantly
    window.mzOptimisticCartUpdate();

    if (cartUpdateTimeouts[key]) {
        clearTimeout(cartUpdateTimeouts[key]);
    }

    const delay = (newQty === 0) ? 50 : 150;

    cartUpdateTimeouts[key] = setTimeout(() => {
        const finalQty = pendingQuantities[key];
        delete pendingQuantities[key];
        delete cartUpdateTimeouts[key];

        const rootUrl = window.Shopify?.routes?.root || '/';
        fetch(rootUrl + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: finalQty })
        })
        .then(res => res.json())
        .then(cart => {
            // Update header badge globally
            const badge = document.querySelector('.mz-cart-count');
            if (badge) {
                badge.textContent = Math.max(0, cart.item_count);
                badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
            }
            
            // Check milestones reward popup immediately using the updated cart response
            if (typeof window.checkCartMilestones === 'function') {
                window.checkCartMilestones(cart);
            }

            // Determine if we need to delay the drawer re-render.
            // Case A: other deletions still in-flight — skip the re-render for now;
            //         it will happen after those finish (or after the delay below).
            // Case B: no more pending changes — re-render immediately.
            const hasPendingDeletions = Object.values(pendingQuantities).some(q => q === 0) ||
                Object.keys(cartUpdateTimeouts).length > 0;

            if (hasPendingDeletions) {
                // Do nothing — a subsequent call from the remaining pending
                // deletion will trigger updateCartDrawer when it finishes.
            } else if (finalQty === 0) {
                // This was the last pending deletion. Delay slightly so that
                // syncMilestoneGifts (triggered by checkCartMilestones above)
                // has time to remove the free-gift server-side before we
                // re-render — otherwise the free gift flashes back on screen.
                setTimeout(() => {
                    if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
                }, 900);
            } else {
                // Quantity change (not a deletion) — safe to re-render immediately.
                if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
            }
            
            // If on cart page, update the cart page section.
            // For deletions (finalQty === 0), delay the refetch so the server
            // has time to confirm the deletion before we re-render — otherwise
            // the deleted item flashes back on screen briefly.
            if (window.location.pathname.indexOf('/cart') !== -1) {
                const doCartPageUpdate = () => {
                    fetch(rootUrl + '?section_id=main-cart')
                        .then(r => r.text())
                        .then(text => {
                            const temp = document.createElement('div');
                            temp.innerHTML = text;
                            const newCart = temp.querySelector('.cart-page-section');
                            const oldCart = document.querySelector('.cart-page-section');
                            if (newCart && oldCart) {
                                oldCart.innerHTML = newCart.innerHTML;
                            }
                        });
                };
                if (finalQty === 0) {
                    setTimeout(doCartPageUpdate, 900);
                } else {
                    doCartPageUpdate();
                }
            }
        })
        .catch(err => {
            console.error(err);
            if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
        })
        .finally(() => {
            // Update checkout button / badge to clear loading state
            window.mzOptimisticCartUpdate();
            // NOTE: updateCartDrawer is intentionally NOT called here again.
            // It is already called in .then() when there are no more pending deletions,
            // and in the effectivelyEmpty path it is delayed to avoid flashing the
            // free-gift item back while syncMilestoneGifts is still running.
        });
    }, delay);
};

window.removeCartItem = function(key) {
    const item = document.querySelector(`.cd-item[data-key="${key}"]`) || document.querySelector(`.cart-item[data-key="${key}"]`);
    if (item) {
        item.style.pointerEvents = 'none';
    }
    window.changeCartQty(key, 0);
};

// ============================================================
// AJAX ADD TO CART - intercepts both sb-form and card-form
// ============================================================
document.addEventListener('submit', function(e) {
    const form = e.target;

    // Match any product form going to /cart/add
    const isCartAddForm = form.matches('form[action*="/cart/add"]') ||
                          form.classList.contains('sb-form') ||
                          form.classList.contains('card-form') ||
                          form.classList.contains('ag-atc-form');

    if (!isCartAddForm) return;

    // Ignore bundle/combo forms (handled by custom scripts)
    if (form.classList.contains('custom-kit-active')) return;

    // Make sure we have a variant id BEFORE preventing default
    // If no variant id found, let the form submit normally to the product page
    const variantInput = form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]');
    if (!variantInput || !variantInput.value) {
        console.warn('[Moraze] No variant ID found in form — letting form submit natively');
        return; // native form submit will proceed (browser handles it)
    }

    // We have a variant id — intercept and use AJAX
    e.preventDefault();

    const formData = new FormData(form);
    const submitBtn = form.querySelector('.sb-atc-btn') ||
                      form.querySelector('button[type="submit"]') ||
                      form.querySelector('.btn-add-to-cart');
    const originalHTML = submitBtn ? submitBtn.innerHTML : '';

    // Show loading state
    if (submitBtn) {
        submitBtn.innerHTML = '⏳ Adding...';
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.75';
    }

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        body: formData
    })
    .then(function(response) {
        return response.json().then(function(data) {
            return { ok: response.ok, data: data };
        });
    })
    .then(function(result) {
        if (!result.ok) {
            // Shopify returned an error (e.g. sold out)
            console.error('[Moraze] Add to cart failed:', result.data.description || result.data);
            alert(result.data.description || 'Could not add product to cart.');
            return;
        }
        // SUCCESS - update drawer, open it, and check for newly unlocked milestones
        if (typeof window.updateCartDrawer === 'function') window.updateCartDrawer();
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        if (typeof window.updateFloatingCartBar === 'function') window.updateFloatingCartBar();
        // Trigger milestone check after add-to-cart so popup fires without needing a page refresh
        if (typeof window.checkCartMilestones === 'function') {
            // Small delay to let updateCartDrawer fetch finish so cart.js returns fresh data
            setTimeout(() => window.checkCartMilestones(), 600);
        }
    })
    .catch(function(error) {
        console.error('[Moraze] Network error adding to cart:', error);
    })
    .finally(function() {
        if (submitBtn) {
            submitBtn.innerHTML = originalHTML || 'ADD TO CART';
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
        }
    });
});

// Override Header Cart Icon click (global delegated listener to match all desktop/mobile/cloned icons)
function initHeaderCart() {
    document.addEventListener('click', function(e) {
        var cartIcon = e.target.closest('.mz-cart-btn, #mzCartIcon, .mz-cart-icon, a[href="/cart"], a[href="/cart/"]');
        if (cartIcon) {
            // Only open drawer if we are not already on the actual cart page
            if (window.location.pathname !== '/cart' && window.location.pathname !== '/cart/') {
                e.preventDefault();
                if (typeof window.openCartDrawer === 'function') {
                    window.openCartDrawer();
                }
            }
        }
    });

    // Override Header Coins Badge click to check activation status
    var coinsBadge = document.getElementById('mzCoinsHeaderBadge');
    if (coinsBadge) {
        coinsBadge.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Check if coins are enabled globally (from Shopify Theme Settings)
            // and NOT blocked via storefront toggle
            const isEnabledInSettings = window.MorazeCoinsConfig?.enabled === true;
            const isBlockedByAdmin = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
            
            if (isEnabledInSettings && !isBlockedByAdmin) {
                // If enabled, navigate to the wallet page
                var href = this.getAttribute('href');
                if (href && href !== '#' && href.indexOf('javascript:') === -1 && href !== '') {
                    window.location.href = href;
                } else {
                    window.location.href = '/pages/my-moraze-coins';
                }
            } else {
                // If disabled/blocked, refresh the current page
                window.location.reload();
            }
        });
    }

    // Check if URL has #cart-open
    if (window.location.hash === '#cart-open') {
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        history.replaceState(null, null, ' ');
    }

    // Init floating cart bar AFTER DOM is ready
    setTimeout(function() {
        if (typeof window.updateFloatingCartBar === 'function') {
            window.updateFloatingCartBar();
        }
    }, 300);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderCart);
} else {
    initHeaderCart();
}

// ============================================================
// FLOATING STICKY CART BAR
// ============================================================
window.updateFloatingCartBar = function() {
    var bar = document.getElementById('floating-cart-bar');
    if (!bar) return;

    // Do not show the floating cart bar on the cart page itself
    if (window.location.pathname.indexOf('/cart') !== -1) {
        bar.classList.remove('visible');
        document.body.classList.remove('has-floating-cart');
        return;
    }

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    fetch(rootUrl + 'cart.js')
        .then(function(res) { return res.json(); })
        .then(function(cart) {

            var countEl = document.getElementById('fcb-item-count');
            var priceEl = document.getElementById('fcb-price');

            if (cart.item_count > 0) {
                bar.classList.add('visible');
                document.body.classList.add('has-floating-cart');
                if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');
                if (priceEl) {
                    var symbol = (window.themeCurrency && window.themeCurrency.symbol) ? window.themeCurrency.symbol : '₹';
                    var isoCode = (window.themeCurrency && window.themeCurrency.isoCode) ? window.themeCurrency.isoCode : 'INR';
                    var dollars = cart.total_price / 100;
                    if (isoCode === 'INR') {
                        var rupees = Math.round(dollars);
                        priceEl.textContent = symbol + rupees.toLocaleString('en-IN');
                    } else {
                        priceEl.textContent = symbol + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    }
                }
            } else {
                bar.classList.remove('visible');
                document.body.classList.remove('has-floating-cart');
            }
        })
        .catch(function(e) { console.error('[Moraze] FCB update error:', e); });
};

// Wrap updateCartDrawer to also refresh floating bar
(function() {
    var _orig = window.updateCartDrawer;
    if (typeof _orig === 'function') {
        window.updateCartDrawer = function() {
            _orig();
            setTimeout(function() {
                if (typeof window.updateFloatingCartBar === 'function') {
                    window.updateFloatingCartBar();
                }
            }, 700);
        };
    }
}());

/* ============================================
   PDP (PRODUCT DETAIL PAGE) LOGIC
   ============================================ */

// Image Gallery
window.updateMainImage = function(element, src) {
    const mainImg = document.getElementById('PdpMainImage');
    if (mainImg) mainImg.src = src;

    // Update active state
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    thumbnails.forEach(t => t.classList.remove('active'));
    element.classList.add('active');
};

// Quantity Selector
window.updatePdpQty = function(change) {
    const qtyInput = document.getElementById('PdpQtyInput');
    if (!qtyInput) return;
    
    let currentQty = parseInt(qtyInput.value) || 1;
    let newQty = currentQty + change;
    
    if (newQty >= 1) {
        qtyInput.value = newQty;
    }
};

// Accordions
document.addEventListener('DOMContentLoaded', () => {
    const headers = document.querySelectorAll('.accordion-header');
    headers.forEach(header => {
        header.addEventListener('click', function() {
            // Toggle active class on header
            this.classList.toggle('active');
            
            // Toggle icon
            const icon = this.querySelector('i');
            if (this.classList.contains('active')) {
                icon.classList.remove('ph-caret-down');
                icon.classList.add('ph-caret-up');
            } else {
                icon.classList.remove('ph-caret-up');
                icon.classList.add('ph-caret-down');
            }
            
            // Toggle content visibility
            const content = this.nextElementSibling;
            if (content.style.display === 'block') {
                content.style.display = 'none';
            } else {
                content.style.display = 'block';
            }
        });
    });
});

/* --- Product Card Click Navigation --- */
document.addEventListener('click', function(e) {
    const card = e.target.closest('.product-card, .sb-product-card, .ag-product-card');
    if (!card) return;
    
    // If click was on or inside a button, form, input, or link — do NOT navigate
    if (e.target.closest('button') ||
        e.target.closest('form') ||
        e.target.closest('a') ||
        e.target.closest('.sb-form') ||
        e.target.closest('.sb-atc-btn') ||
        e.target.closest('.ag-atc-btn') ||
        e.target.closest('.sb-notify-btn') ||
        e.target.closest('.ag-notify-btn') ||
        e.target.tagName === 'BUTTON' ||
        e.target.tagName === 'INPUT') {
        return;
    }

    // Find the product link inside the card
    const link = card.querySelector('a');
    if (link && link.href && link.href !== '#' && !link.href.endsWith('#')) {
        window.location.href = link.href;
    }
});

/* --- ATC / Notify Button: always stop click from bubbling to card nav --- */
document.addEventListener('click', function(e) {
    const btn = e.target.closest('.sb-atc-btn, .sb-notify-btn, .ag-atc-btn, .ag-notify-btn');
    if (!btn) return;
    e.stopPropagation(); // block card-level click navigation
    // Note: do NOT call e.preventDefault() here — that would block form submit!
}, false);



/* --- Mobile Banner Click Navigation --- */
document.addEventListener('click', function(e) {
    const card = e.target.closest('.wth-card-new');
    if (!card) return;
    
    if (e.target.closest('form') || e.target.closest('button') || e.target.closest('a')) {
        return;
    }

    const link = card.querySelector('.wth-card-btn');
    if (link && link.href && link.href !== '#' && !link.href.endsWith('#')) {
        window.location.href = link.href;
    }
});

/* ==========================================================================
   MOBILE TOUCH EVENT & AJAX SUBMISSION FIX (iOS Safari & OnePlus Touch Fix)
   Resolves double-tap hover bugs, click delays, and AJAX interception issues.
   ========================================================================== */
(function() {
    function initMobileTouchFix() {
        const selectors = '#AddToCart, .pdp-sticky-atc, .pdp-atc-btn, .sb-atc-btn, .ag-atc-btn';
        
        // Passive: false is required to let us preventDefault() inside touchstart
        document.addEventListener('touchstart', handleTouchOrClick, { passive: false });
        document.addEventListener('click', handleTouchOrClick);

        let activeTouch = false;
        let lastActionTime = 0;

        function handleTouchOrClick(e) {
            // Ignore programmatic simulated clicks to allow native behaviors like form submits to run
            if (e.isTrusted === false) return;

            const btn = e.target.closest(selectors);
            if (!btn) return;

            // If the element is an anchor link (e.g. multi-variant PDP links), let it navigate natively on mobile.
            const isLink = btn.tagName === 'A' || btn.closest('a');
            if (isLink) return;

            const form = btn.closest('form') || document.getElementById('AddToCartForm');

            // Completely bypass touch/click intervention for Custom Kits & Foundation Builders
            // to allow native user-initiated click events and custom validation/AJAX scripts to execute.
            //
            // We check three signals, from most to least direct:
            //   1. form.custom-kit-active   — set by custom-kit.liquid's script at runtime.
            //   2. btn[data-ck-managed]     — set by custom-kit.liquid's script at runtime,
            //                                  directly on the button.
            //   3. document has .ck-container[data-ck-managed] anywhere on the page —
            //      this is rendered server-side by Liquid and is present in the very
            //      first HTML response, BEFORE any JavaScript executes. Relying on (1)
            //      and (2) alone left a race window on slow mobile renders: this
            //      touchstart/click listener (attached at script parse time) could fire
            //      before custom-kit.liquid's own inline <script> had run far enough to
            //      set the class/attribute, causing stopPropagation() below to silently
            //      swallow the tap before custom-kit.liquid's own handler ever saw it.
            //      Signal (3) has no such timing dependency, so it's checked first.
            const isCustomKit =
                document.querySelector('.ck-container[data-ck-managed]') !== null ||
                (form && form.classList.contains('custom-kit-active')) ||
                btn.hasAttribute('data-ck-managed');

            if (isCustomKit) return;

            const now = Date.now();
            if (now - lastActionTime < 1000) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            if (e.type === 'touchstart') {
                activeTouch = true;
            } else if (e.type === 'click' && activeTouch) {
                activeTouch = false;
                e.preventDefault();
                e.stopPropagation();
                return;
            }

            e.stopPropagation();

            if (btn.classList.contains('pdp-sticky-atc')) {
                e.preventDefault();
                const mainForm = document.getElementById('AddToCartForm');
                if (mainForm) {
                    lastActionTime = now;
                    mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
                return;
            }

            if (form) {
                e.preventDefault();
                lastActionTime = now;
                form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobileTouchFix);
    } else {
        initMobileTouchFix();
    }
})();

// ============================================================
// REDIRECT ADD TO CART FOR SPECIFIC PRODUCTS (TASK 4)
// ============================================================
(function() {
  'use strict';

  const redirectTemplates = ['custom-kit', 'foundation'];

  // 1. Intercept Form Submission (for Add to Cart buttons that submit a form)
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.matches('form[action*="/cart/add"]') || form.classList.contains('ag-atc-form')) {
      const card = form.closest('.ag-product-card');
      if (card) {
        const handle = card.getAttribute('data-product-handle');
        const template = card.getAttribute('data-product-template');
        if (template && redirectTemplates.includes(template)) {
          if (window.location.pathname.indexOf('/products/' + handle) === -1) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = `/products/${handle}#shade-selector`;
          }
        }
      }
    }
  }, true);

  // 2. Intercept Click Events (for Add to Cart links / elements)
  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.ag-atc-btn, button[name="add"], .col-cta-btn');
    if (!btn) return;

    const card = btn.closest('.ag-product-card, .col-card');
    if (card) {
      const handle = card.getAttribute('data-product-handle');
      const template = card.getAttribute('data-product-template');
      if (template && redirectTemplates.includes(template)) {
        if (window.location.pathname.indexOf('/products/' + handle) === -1) {
          e.preventDefault();
          e.stopPropagation();
          window.location.href = `/products/${handle}#shade-selector`;
        }
      }
    }
  }, true);

  // 3. Smooth Scroll to Shade Selector on Product Page Load if Hash Present
  function handleShadeSelectorScroll() {
    if (window.location.hash === '#shade-selector') {
      setTimeout(function() {
        const target = document.getElementById('shade-selector');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleShadeSelectorScroll);
  } else {
    handleShadeSelectorScroll();
  }
})();

/* ==========================================================================
   CART MILESTONE REWARD SYSTEM CONTROLLER (Block-Based)
   Config is read from #mz-milestones-data JSON embedded by cart-drawer.liquid
   ========================================================================== */
(function() {
  'use strict';

  // Read milestone config from the embedded JSON script tag (rendered by cart-drawer.liquid)
  function getMilestonesConfig() {
    const el = document.getElementById('mz-milestones-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch(e) { return null; }
  }

  let isProcessingCart = false;
  let lastKnownTotal = -1;
  let currentPopupMilestone = null;
  const shownMilestones = {};

  // Show the reward popup for a milestone block
  // cartData (optional): already-fetched cart object — avoids an extra network call
  function showRewardPopup(milestone, cartData) {
    currentPopupMilestone = milestone;
    const popup = document.getElementById('mz-reward-popup');
    if (!popup) return;

    const imgEl   = document.getElementById('mz-reward-img');
    const badgeEl = document.getElementById('mz-reward-badge');
    const linkEl  = document.getElementById('mz-reward-link');
    const claimBtn = document.getElementById('mz-reward-claim');

    if (imgEl) {
      imgEl.src = milestone.image || '';
      imgEl.alt = milestone.label;
      imgEl.style.display = milestone.image ? 'block' : 'none';
    }
    if (badgeEl) {
      const lbl = (milestone.label || '').toUpperCase();
      badgeEl.textContent = lbl.startsWith('FREE') ? milestone.label : 'FREE ' + milestone.label;
    }
    if (linkEl) {
      if (milestone.productUrl) {
        linkEl.href = milestone.productUrl;
        linkEl.style.display = 'inline-block';
      } else {
        linkEl.style.display = 'none';
      }
    }

    // Set initial claim button state
    if (claimBtn) {
      claimBtn.textContent = '🎁 Claim Free Gift';
      claimBtn.disabled = false;
    }

    // If we already have cart data (passed from checkCartMilestones), use it directly.
    // This avoids an extra cart.js network request just to check the button state.
    const variantId = parseInt(milestone.variantId, 10);
    if (cartData && cartData.items) {
      const hasGift = cartData.items.some(item =>
        item.variant_id === variantId && item.properties && item.properties._free_gift === 'true'
      );
      if (hasGift && claimBtn) {
        claimBtn.textContent = 'Already Added ✓';
        claimBtn.disabled = true;
      }
    }

    popup.classList.add('open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  // Close the reward popup
  window.closeRewardPopup = function() {
    const popup = document.getElementById('mz-reward-popup');
    if (popup) {
      popup.classList.remove('open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  };

  // Core reward gift claim logic (adds variant to cart with properties)
  // knownCart (optional): cart data we already have — skips the pre-check fetch
  window.confirmRewardGift = async function(knownCart) {
    const milestone = currentPopupMilestone;
    if (!milestone) return;

    const variantId = parseInt(milestone.variantId, 10);
    if (!variantId) {
        console.warn('[Moraze Milestones] No variant ID on this milestone.');
        return;
    }

    const rootUrl = window.Shopify?.routes?.root || '/';

    // Dedup check: use already-available cart data if provided, otherwise
    // do a fast DOM check on visible cart items — avoids an extra network call.
    let hasGift = false;
    if (knownCart && knownCart.items) {
        hasGift = knownCart.items.some(item =>
            item.variant_id === variantId && item.properties && item.properties._free_gift === 'true'
        );
    } else {
        // Fallback: scan DOM for the gift item (instant, no network)
        hasGift = Array.from(document.querySelectorAll('.cd-item[data-is-free-gift="true"]')).some(row => {
            const key = row.getAttribute('data-key') || '';
            return key.toString().startsWith(variantId.toString());
        });
    }

    if (hasGift) {
        console.log('[Moraze] Gift already in cart.');
        return;
    }

    const response = await fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1,
                properties: { 
                    '_free_gift': 'true', 
                    'Gift Status': 'Unlocked' 
                }
            }]
        })
    });
    const data = await response.json();

    if (!response.ok) {
        throw new Error(
            data.description || data.message || 'Gift add nahi ho saka. Dobara try karein.'
        );
    }

    if (typeof window.updateCartDrawer === 'function') {
        window.updateCartDrawer();
    }
  };

  // Claim button click handler inside popup
  window.claimRewardGift = async function() {
    const milestone = currentPopupMilestone;
    const claimBtn = document.getElementById('mz-reward-claim');

    if (!milestone) { 
        window.closeRewardPopup(); 
        return; 
    }

    const origText = claimBtn ? claimBtn.textContent : '';
    if (claimBtn) { 
        claimBtn.textContent = 'Adding...'; 
        claimBtn.disabled = true; 
    }

    try {
        await window.confirmRewardGift();
        window.closeRewardPopup();
    } catch (err) {
        console.error('[Moraze] claimRewardGift failed:', err.message);
        alert(err.message);
        if (claimBtn) { 
            claimBtn.textContent = origText || '🎁 Claim Free Gift'; 
            claimBtn.disabled = false; 
        }
    }
  };

  // Claim button click handler inside Cart Drawer milestone progress tracker
  window.claimMilestoneGift = async function(blockIndex, btnElement) {
    const el = document.getElementById('mz-milestones-data');
    if (!el) return;
    let cfg;
    try { cfg = JSON.parse(el.textContent); } catch(e) { return; }
    if (!cfg || !cfg.milestones || !cfg.milestones[blockIndex]) return;
    const milestone = cfg.milestones[blockIndex];
    currentPopupMilestone = milestone;

    let origText = '';
    if (btnElement) {
      origText = btnElement.textContent;
      btnElement.textContent = 'Adding...';
      btnElement.disabled = true;
    }

    try {
      await window.confirmRewardGift();
    } catch (err) {
      console.error('[Moraze] claimMilestoneGift failed:', err.message);
      alert(err.message);
    } finally {
      if (btnElement) {
        btnElement.textContent = origText || 'Claim';
        btnElement.disabled = false;
      }
    }
  };

  // Sync general cart indicators (badge + floating bar)
  function updateCartIndicators() {
    const rootUrl = window.Shopify?.routes?.root || '/';
    fetch(rootUrl + 'cart.js')
      .then(res => res.json())
      .then(cart => {
        const badge = document.querySelector('.mz-cart-count');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
        if (typeof window.updateFloatingCartBar === 'function') {
          window.updateFloatingCartBar();
        }
      })
      .catch(e => console.error('[Moraze Milestones] Error updating indicators:', e));
  }

  // Synchronize free gifts in cart based on cart subtotal (Promise-based)
  function syncMilestoneGifts(cart) {
    if (!cart || !cart.items) return Promise.resolve(false);

    const cfg = getMilestonesConfig();
    console.log('[Moraze Milestones] Sync config:', cfg);
    if (!cfg || !cfg.milestones || cfg.milestones.length === 0) {
      console.warn('[Moraze Milestones] No milestones configuration found on this page.');
      return Promise.resolve(false);
    }

    // 1. Calculate base total excluding free gifts
    let baseTotal = 0;
    cart.items.forEach(item => {
      const isGift = item.properties && item.properties._free_gift === 'true';
      if (!isGift) baseTotal += item.final_line_price;
    });
    const baseTotalRupees = baseTotal / 100;
    console.log('[Moraze Milestones] Base cart total (excluding gifts): ₹' + baseTotalRupees);

    const itemsToAdd = [];
    const itemsToRemove = [];

    // 2. Check each milestone eligibility
    cfg.milestones.forEach(m => {
      const variantId = parseInt(m.variantId, 10);
      if (!variantId) {
        console.warn('[Moraze Milestones] Milestone skipped (no variantId configured):', m);
        return;
      }

      const hasGiftInCart = cart.items.some(item => {
        return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
      });

      const isEligible = baseTotalRupees >= m.threshold;
      console.log('[Moraze Milestones] Milestone check:', {
        label: m.label,
        threshold: m.threshold,
        variantId: variantId,
        isEligible: isEligible,
        hasGiftInCart: hasGiftInCart
      });

      if (isEligible && !hasGiftInCart) {
        console.log('[Moraze Milestones] Gift eligible but not in cart. Requires manual claim.');
      } else if (!isEligible && hasGiftInCart) {
        const giftItem = cart.items.find(item => {
          return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
        });
        if (giftItem) {
          console.log('[Moraze Milestones] Queueing gift to REMOVE:', m.label);
          itemsToRemove.push(giftItem.key);
        }
      }
    });

    if (itemsToRemove.length === 0 && itemsToAdd.length === 0) {
      console.log('[Moraze Milestones] No changes needed (all gifts in sync).');
      return Promise.resolve(false);
    }

    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    let promise = Promise.resolve();

    // Perform removals sequentially
    itemsToRemove.forEach(key => {
      promise = promise.then(() => {
        console.log('[Moraze Milestones] Removing gift key:', key);
        return fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(e => console.error('[Moraze Milestones] Error removing gift:', e));
      });
    });

    // Perform additions
    if (itemsToAdd.length > 0) {
      promise = promise.then(() => {
        console.log('[Moraze Milestones] Adding gifts payload:', itemsToAdd);
        return fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd })
        }).catch(e => console.error('[Moraze Milestones] Error adding gift:', e));
      });
    }

    return promise.then(() => {
      console.log('[Moraze Milestones] Cart sync updates completed.');
      return true;
    });
  }

  // Main milestone check — auto-adds/removes gifts and shows popup (Promise-based)
  window.checkCartMilestones = function(cartData = null) {
    if (isProcessingCart) return;
    isProcessingCart = true;

    console.log('[Moraze Milestones] Running checkCartMilestones...');
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

    let cartPromise;
    if (cartData) {
      cartPromise = Promise.resolve(cartData);
    } else {
      cartPromise = fetch(rootUrl + 'cart.js').then(res => res.json());
    }

    cartPromise.then(cart => {
      // 1. Calculate base total excluding free gifts
      let baseTotal = 0;
      if (cart && cart.items) {
        cart.items.forEach(item => {
          const isGift = item.properties && item.properties._free_gift === 'true';
          if (!isGift) baseTotal += item.final_line_price;
        });
      }
      const baseTotalRupees = baseTotal / 100;

      // Update indicators
      updateCartIndicators();

      // 2. Read block config
      const cfg = getMilestonesConfig();
      if (!cfg || !cfg.milestones || cfg.milestones.length === 0) {
        console.warn('[Moraze Milestones] Milestones config is missing or empty.');
        isProcessingCart = false;
        return;
      }

      // 3. Determine if popup should show
      if (baseTotalRupees !== lastKnownTotal) {
        const prevTotal = lastKnownTotal;
        lastKnownTotal = baseTotalRupees;

        // If the cart total dropped BELOW a milestone threshold, clear that milestone
        // from shownMilestones so the popup can fire again if they re-qualify later.
        cfg.milestones.forEach(m => {
          if (baseTotalRupees < m.threshold && shownMilestones[m.variantId]) {
            delete shownMilestones[m.variantId];
            console.log('[Moraze Milestones] Reset shown state for milestone (total dropped):', m.label);
          }
        });

        const newlyUnlocked = cfg.milestones.filter(m => {
          const variantId = parseInt(m.variantId, 10);
          const hasGiftInCart = cart.items.some(item => {
            return item.variant_id === variantId && item.properties && item.properties._free_gift === 'true';
          });
          
          if (hasGiftInCart || shownMilestones[m.variantId]) {
            return false;
          }

          // Case A: Just crossed the threshold (prevTotal was below, current is above)
          const justCrossed = prevTotal >= 0 && prevTotal < m.threshold && baseTotalRupees >= m.threshold;
          
          // Case B: Initial load and already above threshold
          const initialLoadEligible = prevTotal === -1 && baseTotalRupees >= m.threshold;

          return justCrossed || initialLoadEligible;
        });

        if (newlyUnlocked.length > 0) {
          newlyUnlocked.sort((a, b) => b.threshold - a.threshold);
          const top = newlyUnlocked[0];
          console.log('[Moraze Milestones] Showing popup for milestone:', top.label);
          // Pass cart data so showRewardPopup can check button state instantly
          showRewardPopup(top, cart);
          
          // Mark as shown so we don't prompt again in this runtime session
          newlyUnlocked.forEach(m => {
            shownMilestones[m.variantId] = true;
          });
        }
      }

      // 4. Sync free gifts (add/remove) in background
      return syncMilestoneGifts(cart).then(changed => {
        if (changed) {
          console.log('[Moraze Milestones] Cart changed, updating cart drawer DOM...');
          isProcessingCart = false;
          if (typeof window.updateCartDrawer === 'function') {
            window.updateCartDrawer();
          }
        }
      });

    }).catch(error => {
      console.error('[Moraze Milestones] Error in checkCartMilestones:', error);
    }).finally(() => {
      isProcessingCart = false;
    });
  };

  // Event Listeners
  function initMilestones() {
    const closeBtn    = document.getElementById('mz-reward-close');
    const continueBtn = document.getElementById('mz-reward-continue');
    const popup       = document.getElementById('mz-reward-popup');

    if (closeBtn) {
      closeBtn.removeEventListener('click', window.closeRewardPopup);
      closeBtn.addEventListener('click', window.closeRewardPopup);
    }
    if (continueBtn) {
      continueBtn.removeEventListener('click', window.confirmRewardGift);
      continueBtn.addEventListener('click', window.confirmRewardGift);
    }
    if (popup) {
      popup.addEventListener('click', e => {
        if (e.target === popup) window.closeRewardPopup();
      });
    }

    // Initial cart check (sets lastKnownTotal without showing popup)
    window.checkCartMilestones();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMilestones);
  } else {
    initMilestones();
  }

  // Re-check milestones instantly when drawer updates
  document.addEventListener('cart-drawer:updated', () => {
    if (typeof window.checkCartMilestones === 'function') {
      window.checkCartMilestones();
    }
  });
})();

/* ==========================================================================
   ADMIN MANUAL GIFT ADDER (Block-Index based)
   Visible only to staff/admin-tagged customers or in design_mode
   ========================================================================== */
window.mzAdminAddGiftBlock = async function(blockIndex) {
  const cfgEl = document.getElementById('mz-milestones-data');
  if (!cfgEl) { alert('Milestone config not found on this page.'); return; }
  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch(e) { alert('Config parse error.'); return; }

  const milestone = cfg.milestones && cfg.milestones[blockIndex];
  if (!milestone) { alert('Milestone block #' + blockIndex + ' not found.'); return; }

  const btn = event && event.target;
  const origText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = '⏳ Adding...'; btn.disabled = true; }

  const variantId = parseInt(milestone.variantId, 10);
  if (!variantId) {
    alert('Could not find a valid variant ID for "' + milestone.label + '". Please make sure a product is selected in the block settings.');
    if (btn) { btn.textContent = origText; btn.disabled = false; }
    return;
  }

  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  
  try {
    const response = await fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_free_gift': 'true',
            'Gift Status': 'Manual'
          }
        }]
      })
    });
    
    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.description || 'Could not add manual gift.');
    }
    
    // Success - update drawer
    if (typeof window.updateCartDrawer === 'function') {
      window.updateCartDrawer();
    }
  } catch (error) {
    console.error('[Moraze Admin] Error adding manual gift:', error);
    alert('Error adding gift: ' + error.message);
  } finally {
    if (btn) { btn.textContent = origText; btn.disabled = false; }
  }
};

/* ==========================================================================
   TRUSTOO DYNAMIC REVIEWS MUTATIONOBSERVER (CENTRALIZED)
   ========================================================================== */
function initTrustooCardsObserver() {
    if (!document.querySelector('.ag-product-card')) return;

    function getReviewsFallback(title, handle) {
        title = (title || '').toLowerCase();
        handle = (handle || '').toLowerCase();

        // Explicitly exclude 4 trending kits since they have 0 reviews in reality
        if (title.indexOf('4 trending') !== -1 || handle.indexOf('4-trending') !== -1) {
            return null;
        }

        if (title.indexOf('3 ultra soft') !== -1 || handle.indexOf('3-ultra-soft') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        if (title.indexOf('4 glamorous') !== -1 || handle.indexOf('4-glamorous') !== -1) {
            return { rating: 4.9, count: "350+" };
        }
        if (title.indexOf('4 must-have') !== -1 || handle.indexOf('4-must-have') !== -1) {
            return { rating: 4.8, count: "300+" };
        }
        if (title.indexOf('4 ultra soft') !== -1 || handle.indexOf('4-ultra-soft') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        if (title.indexOf('lipstick kit') !== -1 || handle.indexOf('lipstick-kit') !== -1) {
            return { rating: 4.9, count: "150+" };
        }
        return null;
    }

    function updateCardElement(card) {
        var hiddenWidget = card.querySelector('.trustoo-hidden-card-widget');
        if (!hiddenWidget) return false;
        
        var text = hiddenWidget.textContent.trim();
        var title = (card.dataset.productTitle || '').toLowerCase();
        var handle = (card.dataset.productHandle || '').toLowerCase();
        var fallback = getReviewsFallback(title, handle);

        if (!text) {
            // Trustoo reviews haven't loaded yet.
            // If this is a grouped lipstick kit, apply fallback reviews immediately to prevent 0 reviews showing
            if (fallback) {
                var ratingValEl = card.querySelector('.ag-card-rating-val');
                var countEls = card.querySelectorAll('.ag-card-reviews-count');
                var ratingRow = card.querySelector('.ag-card-rating-row');
                
                if (ratingValEl) ratingValEl.textContent = fallback.rating.toFixed(1);
                if (countEls.length > 0) {
                    countEls.forEach(function(el) {
                        el.textContent = fallback.count;
                    });
                }
                if (ratingRow) {
                    ratingRow.style.setProperty('display', 'flex', 'important');
                }
                card.dataset.trustooProcessed = "true";
                return true;
            }

            // If the native Shopify review count is 0, hide the rating row to prevent displaying "0 Reviews"
            var ratingRow = card.querySelector('.ag-card-rating-row');
            var countEl = card.querySelector('.ag-card-reviews-count');
            var initialCount = countEl ? parseInt(countEl.textContent, 10) : 0;
            if ((isNaN(initialCount) || initialCount === 0) && ratingRow) {
                ratingRow.style.setProperty('display', 'none', 'important');
            }
            return false;
        }

        if (card.dataset.trustooProcessed === "true") return true;

        // 1. Extract all numbers (decimals and integers)
        var numbers = text.match(/\d+(\.\d+)?/g) || [];
        if (numbers.length === 0) return false;
        
        // 2. Extract review count
        var countMatch = text.match(/\((\d+)\)/);
        var reviewWordMatch = text.match(/(\d+)\s*(?:reviews?|customer reviews?)/i);
        var count = null;
        if (countMatch) {
            count = parseInt(countMatch[1]);
        } else if (reviewWordMatch) {
            count = parseInt(reviewWordMatch[1]);
        }

        // 3. Classify parsed numbers (distinguish floats and integers with decimal checking)
        var parsedNumbers = [];
        for (var i = 0; i < numbers.length; i++) {
            parsedNumbers.push({
                val: parseFloat(numbers[i]),
                str: numbers[i],
                hasDot: numbers[i].indexOf('.') !== -1
            });
        }

        // If any parsed number is > 5.0, it must be the review count, not a rating
        for (var i = 0; i < parsedNumbers.length; i++) {
            if (parsedNumbers[i].val > 5.0) {
                if (count === null) {
                    count = Math.round(parsedNumbers[i].val);
                }
            }
        }

        // Remove count from parsedNumbers if found
        if (count !== null) {
            for (var i = 0; i < parsedNumbers.length; i++) {
                if (Math.round(parsedNumbers[i].val) === count) {
                    parsedNumbers.splice(i, 1);
                    break;
                }
            }
        }

        // Extract rating
        var rating = null;

        // Look for rating candidate in remaining numbers
        if (parsedNumbers.length > 0) {
            // Prioritize float rating (has a decimal point and is between 1.0 and 5.0)
            var decimalRating = null;
            for (var i = 0; i < parsedNumbers.length; i++) {
                var p = parsedNumbers[i];
                if (p.hasDot && p.val >= 1.0 && p.val <= 5.0) {
                    decimalRating = p.val;
                    break;
                }
            }

            if (decimalRating !== null) {
                rating = decimalRating;
            } else {
                // Otherwise look for any number between 1.0 and 5.0
                var normalRating = null;
                for (var i = 0; i < parsedNumbers.length; i++) {
                    var p = parsedNumbers[i];
                    if (p.val >= 1.0 && p.val <= 5.0) {
                        normalRating = p.val;
                        break;
                    }
                }
                if (normalRating !== null) {
                    rating = normalRating;
                } else {
                    // Fallback to the first parsed number's value, but only if it's <= 5.0
                    if (parsedNumbers[0].val <= 5.0) {
                        rating = parsedNumbers[0].val;
                    }
                }
            }
        }

        // Fallback for count and rating if not resolved
        if (count === null) {
            if (rating !== null) {
                for (var i = 0; i < parsedNumbers.length; i++) {
                    if (parsedNumbers[i].val === rating) {
                        parsedNumbers.splice(i, 1);
                        break;
                    }
                }
            }
            if (parsedNumbers.length > 0) {
                count = Math.round(parsedNumbers[0].val);
            } else if (rating !== null && /reviews?/i.test(text)) {
                count = Math.round(rating);
                rating = null;
            }
        }

        if (rating === null) {
            var ratingValEl = card.querySelector('.ag-card-rating-val');
            if (ratingValEl) {
                var currentRating = parseFloat(ratingValEl.textContent);
                if (!isNaN(currentRating) && currentRating > 1.0 && currentRating <= 5.0) {
                    rating = currentRating;
                } else if (count > 0) {
                    rating = 5.0;
                }
            }
        }

        // Force override if rating is <= 1.0 or > 5.0
        if (rating !== null && !isNaN(rating)) {
            if (rating <= 1.0 || rating > 5.0) {
                if (count > 0) {
                    rating = 5.0;
                } else {
                    rating = 4.9;
                }
            }
        }

        // Apply fallback reviews if Trustoo loaded reviews as 0/empty for lipstick kits
        if ((rating === null || count === 0) && fallback) {
            rating = fallback.rating;
            count = fallback.count;
        }

        // If we don't have a valid rating yet, wait for Trustoo to finish injecting the real content

        if (rating === null) {
            return false;
        }

        var ratingValEl = card.querySelector('.ag-card-rating-val');
        var countEls = card.querySelectorAll('.ag-card-reviews-count');
        var ratingRow = card.querySelector('.ag-card-rating-row');

        if (ratingValEl) {
            ratingValEl.textContent = rating.toFixed(1);
        }
        if (count !== null && count !== undefined && countEls.length > 0) {
            countEls.forEach(function(el) {
                el.textContent = count;
            });
            var hasCount = false;
            if (typeof count === 'string') {
                hasCount = count.trim().length > 0 && count !== '0';
            } else {
                hasCount = !isNaN(count) && count > 0;
            }
            if (hasCount && ratingRow) {
                ratingRow.style.setProperty('display', 'flex', 'important');
            } else if (ratingRow) {
                ratingRow.style.setProperty('display', 'none', 'important');
            }
        }
        
        card.dataset.trustooProcessed = "true";
        return true;
    }

    document.querySelectorAll('.ag-product-card').forEach(updateCardElement);

    const catalogContainer = document.querySelector('.main-content, #MainContent');
    if (catalogContainer) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                let node = mutation.target;
                if (node.nodeType === Node.TEXT_NODE) {
                    node = node.parentElement;
                }
                if (node && node.closest) {
                    const widget = node.closest('.trustoo-hidden-card-widget');
                    if (widget) {
                        const card = widget.closest('.ag-product-card');
                        if (card) {
                            updateCardElement(card);
                        }
                    }
                }
            });
        });

        observer.observe(catalogContainer, {
            childList: true,
            subtree: true,
            characterData: true
        });
    }
}

/* ==========================================================================
   ADMIN MANUALLY BLOCK/UNBLOCK MORAZE COINS
   ========================================================================== */
window.mzAdminToggleCoinsStatus = function() {
    const isBlocked = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
    const nextStatus = !isBlocked;
    localStorage.setItem('moraze_coins_disabled_globally', nextStatus ? 'true' : 'false');
    
    // Update button text & colors
    const btn = document.getElementById('mz-admin-coins-toggle');
    if (btn) {
        btn.textContent = nextStatus ? '🔴 Coins: BLOCKED (Click to Unblock)' : '🟢 Coins: ACTIVE (Click to Block)';
        btn.style.background = nextStatus ? '#fef2f2' : '#ecfdf5';
        btn.style.color = nextStatus ? '#dc2626' : '#059669';
        btn.style.borderColor = nextStatus ? '#fca5a5' : '#a7f3d0';
    }

    // Hide/show the coins widget in the DOM dynamically
    const widgets = document.querySelectorAll('#moraze-coins-cart-root, #moraze-coins-widget, .mc-cart-widget, #moraze-coins-redeem-widget, #moraze-coins-account-root, .moraze-coins-tab-wrapper, .moraze-wallet-card, .sb-coins-card, .mz-wallet-section');
    widgets.forEach(w => {
        w.style.display = nextStatus ? 'none' : '';
    });

    // Optionally send update to backend API
    const rootUrl = window.Shopify?.routes?.root || '/';
    fetch(rootUrl + 'apps/moraze-coins/api/toggle-status', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            admin_id: window.MorazeCoinsConfig?.customerId || 'admin',
            blocked: nextStatus
        })
    }).catch(e => console.warn('Mock toggle sync failed:', e));

    // Reload the page after a brief delay to completely reset controllers
    setTimeout(() => {
        window.location.reload();
    }, 600);
};

window.mzAdminInitCoinsToggle = function() {
    // 1. Check URL parameters for admin_mode override
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('admin_mode') === 'true') {
        localStorage.setItem('mz_admin_mode', 'true');
    } else if (urlParams.get('admin_mode') === 'false') {
        localStorage.removeItem('mz_admin_mode');
    }

    // 2. Check if the user should see the admin panel
    const hasAdminTags = window.MorazeCoinsConfig?.isAdmin === true;
    const isDesignMode = (window.Shopify && window.Shopify.designMode === true) || window.location.href.indexOf('design_mode=true') !== -1;
    const isLocalStorageAdmin = localStorage.getItem('mz_admin_mode') === 'true';

    const showAdminPanel = hasAdminTags || isDesignMode || isLocalStorageAdmin;
    const adminPanel = document.getElementById('mz-admin-gift-panel');
    if (adminPanel) {
        adminPanel.style.display = showAdminPanel ? 'block' : 'none';
    }

    // 3. Update the Coins Block/Unblock toggle status button
    const isBlocked = localStorage.getItem('moraze_coins_disabled_globally') === 'true';
    const btn = document.getElementById('mz-admin-coins-toggle');
    if (btn) {
        btn.textContent = isBlocked ? '🔴 Coins: BLOCKED (Click to Unblock)' : '🟢 Coins: ACTIVE (Click to Block)';
        btn.style.background = isBlocked ? '#fef2f2' : '#ecfdf5';
        btn.style.color = isBlocked ? '#dc2626' : '#059669';
        btn.style.borderColor = isBlocked ? '#fca5a5' : '#a7f3d0';
    }

    // 4. Hide/show widgets accordingly
    if (isBlocked) {
        const widgets = document.querySelectorAll('#moraze-coins-cart-root, #moraze-coins-widget, .mc-cart-widget, #moraze-coins-redeem-widget, #moraze-coins-account-root, .moraze-coins-tab-wrapper, .moraze-wallet-card, .sb-coins-card, .mz-wallet-section');
        widgets.forEach(w => {
            w.style.display = 'none';
        });
    }
};

// Listeners to initialize states
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.mzAdminInitCoinsToggle);
} else {
    window.mzAdminInitCoinsToggle();
}
document.addEventListener('cart-drawer:updated', window.mzAdminInitCoinsToggle);
